// extracted by mini-css-extract-plugin
export default {"callBackToMain":"CallBackToMain_callBackToMain__BpdTO","link":"CallBackToMain_link__qV-9s"};